import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from '@repo/app-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import router from './app/router';
// import { env } from '@repo/environment';
// if (env.PUBLIC_USE_SENTRY) {
//   Sentry.init({
//     dsn: env.PUBLIC_SENTRY_DSN,
//     environment: env.PUBLIC_ENV,
//     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: false })],
//     tracesSampleRate: 1.0,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     release: env.PUBLIC_SENTRY_RELEASE,
//     ignoreErrors: [
//       // This error is thrown when link scanners (mainly Outlook 365) tries to scan our links
//       /^Non-Error promise rejection captured with value: Object Not Found Matching Id:/i,
//     ],
//   });
// }
const rootElement = document.getElementById('root');
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(/*#__PURE__*/ _jsx(StrictMode, {
        children: /*#__PURE__*/ _jsx(RouterProvider, {
            router: router
        })
    }));
}
